<template>
    <v-container fluid>
        <v-toolbar color="#FAFAFA" flat>
            <v-btn icon outline color="black" to="/compositores">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title >{{toolbarName}} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn dark color="green" @click="$refs.compositor_info_ref.salvar()">Salvar</v-btn>
        </v-toolbar>
    <v-divider></v-divider>
        <template>
            <compositor_info :compositor_id="item_id" ref="compositor_info_ref" />
        </template>

        
    </v-container>
</template>

<script>
import compositor_info from "../../components/compositores/compositor_info";

export default {
    components: {
        compositor_info
               
    },
    data() {
        return {
            item_id: 0
        };
    },
    created() {
        this.item_id = this.$route.params.id;
    },
    computed:{
      toolbarName: function(){
        if(this.item_id){
          return 'Editar Compositor';
        }else{
          return 'Novo Compositor';
        }
      }
    }
};
</script>


